import React, { Component } from 'react';
import { Modal, Spin, Input, message, Select } from 'antd';
import API_URL from '../../../../common/url';
import $ from '../../../../common/AjaxRequest';

const { Option } = Select;

class CloneVisit extends Component {
    state = {
        visible: false,
        loading: false,
        data: {},
    }

    show = () => {
        const { panes } = this.props;
        const newVisitGroupingName = `访视方案${panes[panes.length - 1].item + 1}`
        this.setState({
            visible: true,
            data: { newVisitGroupingName }
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    submit = () => {
        const { data } = this.state;
        const { newVisitGroupingName } = data;
        if (!newVisitGroupingName || !newVisitGroupingName.trim()) {
            return message.warning('新建访视方案名称不能为空!');
        }
        this.setState({ loading: true });
        $.sendRequest({
            method: 'POST',
            url: API_URL.plan.copyVisitGrouping,
            data: { ...data },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.hide();
                this.setState({ loading: false }, () => {
                    this.props.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        });
    }

    handleChange = (value, key) => {
        const { data } = this.state;
        switch (key) {
            default:
                data[key] = value;
                break;
        }
        this.setState({ data });
    }

    render () {
        const { panes } = this.props;
        const { visible, loading, data } = this.state;
        const Options = panes.map(item => <Option key={item.visitGroupingId}>{item.visitGroupingName}</Option>);
        const asterisk = <span style={{ color: 'red' }}>*</span>;
        return (
            <Modal
                title="复制新建访视方案"
                visible={visible}
                onOk={this.submit}
                onCancel={this.hide}
                confirmLoading={loading}
                maskClosable={false}
                width="420px"
            >
                <Spin spinning={loading}>
                    <div className="modal-content" style={{ padding: 0 }}>
                        <ul className="modal-list">
                            <li className="modal-item">
                                <div className="item-left">复制对象:</div>
                                <div className="item-right">
                                    <Select
                                        allowClear={true}
                                        placeholder="请选择"
                                        style={{ width: 160 }}
                                        value={data.visitGroupingId ? String(data.visitGroupingId) : undefined}
                                        onChange={value => this.handleChange(value, 'visitGroupingId')}
                                    >
                                        { Options }
                                    </Select>
                                </div>
                            </li>
                            <li className="modal-item">
                                <div className="item-left">{asterisk}新建访视方案名称:</div>
                                <div className="item-right">
                                    <Input
                                        placeholder='请输入'
                                        style={{ width: 160 }}
                                        value={data.newVisitGroupingName}
                                        onChange={e => this.handleChange(e.target.value, 'newVisitGroupingName')}
                                    />
                                </div>
                            </li>
                        </ul>
                    </div>
                </Spin>
            </Modal>
        );
    }
}

export default CloneVisit;


// WEBPACK FOOTER //
// ./src/components/executeMgr/visitPeriodPlan/components/CloneVisit.js